<template>
  <div
    class="dynamic-stars flex-center gap-1 text-sm text-gray-700"
    :class="rating === 0 && count === 0 ? 'opacity-30' : ''"
    role="img"
    :aria-label="ariaLabel"
  >
    <div class="h-5 flex gap-0.5 justify-center items-center">
      <svg
        v-for="star in fullStars"
        :key="star"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        class="h-3 w-3"
      >
        <title>Filled star</title>
        <path
          d="m3.2 16.0001081c-.1687782 0-.33328968-.0531313-.47-.1521081-.24051968-.174488-.36451194-.4679107-.322-.762l.743-5.203-2.917-2.917c-.21191095-.21196521-.28756133-.52460199-.196-.81.09130759-.2851682.3345701-.49522345.63-.544l4.398-.734 2.218-4.435c.13744692-.27145241.41573373-.4426761.72-.443.3045618.00166772.58175678.1761261.715.45l2.123 4.362 4.498.801c.2933158.05211246.5333796.26289081.623.547.0898959.28455453.0135125.59548872-.198.806l-2.917 2.917.744 5.203c.042199.2957461-.0839008.5903645-.327.764-.2421349.1739598-.5609835.1986349-.827.064l-4.382-2.22-4.502 2.223c-.10996656.0547452-.23116004.0831081-.354.0831081z"
          fill="var(--junipStarColor)"
        />
      </svg>
      <svg
        v-if="partialStar > 0"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        class="h-3 w-3 text-junip-star-color"
      >
        <title>Mask star</title>
        <!-- mask -->
        <defs>
          <mask :id="`star-mask-${rating}`">
            <rect
              x="3"
              y="0"
              :width="(10 * partialStar)"
              height="16"
              fill="white"
            />
          </mask>
        </defs>
        <!-- outline -->
        <path
          d="M3.2,16C3.031,16 2.867,15.947 2.73,15.848C2.489,15.674 2.365,15.38 2.408,15.086L3.151,9.883L0.234,6.966C0.022,6.754 -0.054,6.441 0.038,6.156C0.129,5.871 0.373,5.661 0.668,5.612L5.066,4.878L7.284,0.443C7.421,0.172 7.696,0 8,0C8.305,0.002 8.586,0.176 8.719,0.45L10.842,4.812L15.34,5.613C15.633,5.665 15.873,5.876 15.963,6.16C16.053,6.445 15.977,6.755 15.765,6.966L12.848,9.883L13.592,15.086C13.634,15.382 13.508,15.676 13.265,15.85C13.023,16.024 12.704,16.049 12.438,15.914L8,13.694L3.554,15.917C3.444,15.972 3.323,16 3.2,16ZM4.71,13.116L8,11.458L11.286,13.088L10.726,9.176L12.724,7.179L9.49,6.603L8,3.512L6.4,6.683L3.297,7.201L5.272,9.176L4.71,13.116Z"
          fill="var(--junipStarColor)"
        />
        <!-- fill -->
        <path
          d="M3.2,16C3.031,16 2.867,15.947 2.73,15.848C2.489,15.674 2.365,15.38 2.408,15.086L3.151,9.883L0.234,6.966C0.022,6.754 -0.054,6.441 0.038,6.156C0.129,5.871 0.373,5.661 0.668,5.612L5.066,4.878L7.284,0.443C7.421,0.172 7.696,0 8,0C8.305,0.002 8.586,0.176 8.719,0.45L10.842,4.812L15.34,5.613C15.633,5.665 15.873,5.876 15.963,6.16C16.053,6.445 15.977,6.755 15.765,6.966L12.848,9.883L13.592,15.086C13.634,15.382 13.508,15.676 13.265,15.85C13.023,16.024 12.704,16.049 12.438,15.914L8,13.694L3.554,15.917C3.444,15.972 3.323,16 3.2,16Z"
          fill="var(--junipStarColor)"
          :mask="`url(#star-mask-${rating})`"
        />
      </svg>
      <svg
        v-for="star in emptyStars"
        :key="star"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        class="h-3 w-3"
      >
        <title>Empty star</title>
        <path
          d="M3.2,16C3.031,16 2.867,15.947 2.73,15.848C2.489,15.674 2.365,15.38 2.408,15.086L3.151,9.883L0.234,6.966C0.022,6.754 -0.054,6.441 0.038,6.156C0.129,5.871 0.373,5.661 0.668,5.612L5.066,4.878L7.284,0.443C7.421,0.172 7.696,0 8,0C8.305,0.002 8.586,0.176 8.719,0.45L10.842,4.812L15.34,5.613C15.633,5.665 15.873,5.876 15.963,6.16C16.053,6.445 15.977,6.755 15.765,6.966L12.848,9.883L13.592,15.086C13.634,15.382 13.508,15.676 13.265,15.85C13.023,16.024 12.704,16.049 12.438,15.914L8,13.694L3.554,15.917C3.444,15.972 3.323,16 3.2,16ZM4.71,13.116L8,11.458L11.286,13.088L10.726,9.176L12.724,7.179L9.49,6.603L8,3.512L6.4,6.683L3.297,7.201L5.272,9.176L4.71,13.116Z"
          fill="var(--junipStarColor)"
        />
      </svg>
    </div>
    <span
      v-if="rating && count"
      class="font-medium"
    >
      {{ Math.round(rating * 100) / 100 }} ({{ count }})
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
export interface Props {
  rating: number
  count: number
}
const props = defineProps<Props>()
const fullStars = computed(() => Math.floor(props.rating))
const emptyStars = computed(() => 5 - Math.ceil(props.rating))
const partialStar = computed(() => props.rating - Math.floor(props.rating))
const ariaLabel = computed(() => {
  if (props.rating && props.count) {
    return `${props.rating.toFixed(2)} stars, ${props.count} reviews`
  } else {
    return 'no rating'
  }
})
</script>
